(function () {
  function initJourney(root) {
    if (root.dataset.journeyInit === 'true') return;
    root.dataset.journeyInit = 'true';

    var toggle = root.querySelector('.ooak-journey__toggle');
    if (!toggle) return;

    toggle.addEventListener('click', function () {
      var isOpen = root.getAttribute('data-open') === 'true';
      root.setAttribute('data-open', isOpen ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  }

  function initAll() {
    document.querySelectorAll('.ooak-journey').forEach(initJourney);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();